export const ActionTypes = {
    SET_ALLOWED_PROMPTS: "ANALYZE_DATA/SET_ALLOWED_PROMPTS",
    FETCH_ALLOWED_PROMPTS: "ANALYZE_DATA/FETCH_ALLOWED_PROMPTS",
};

export const actions = {
    fetchAllowedPrompts: () => ({
        type: ActionTypes.FETCH_ALLOWED_PROMPTS,
    }),
    setAllowedPrompts: (payload) => ({
        type: ActionTypes.SET_ALLOWED_PROMPTS,
        payload,
    }),
};
